import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { NavigationExtras } from '@angular/router';
import * as moment from 'moment';
import { AccessService } from 'src/app/providers/access/access.service';
@Component({
  selector: 'app-add-speciality',
  templateUrl: './add-speciality.page.html',
  styleUrls: ['./add-speciality.page.scss'],
})
export class AddSpecialityPage implements OnInit {
  specialityForm: FormGroup;
  // eslint-disable-next-line max-len
  successMessage = 'We have received your request to %, and our team will be in touch within one business day.<br/><br/> If you would like to discuss this right now please call us on <a href="tel:1300 809 484">1300 809 484</a>';
  DateQualified: any;
  constructor(
    private navCtrl: NavController,
    public formBuilder: FormBuilder,
    public apiService: ApiService,
    public toastService: ToastService,
    public accessService: AccessService,
) {
    this.specialityForm = this.formBuilder.group({
      type: ['', [Validators.required]],
      specialty: ['', [Validators.required]],
      dateQualified: [moment().format(), [Validators.required]],
    });
  }

  ngOnInit() {
    this.DateQualified = moment().format();
  }
  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }
  onSubmitForm() {
    if (this.specialityForm.valid) {
      this.specialityForm.controls.dateQualified.setValue(new Date(this.specialityForm.get('dateQualified').value).toLocaleDateString());
      this.toastService.presentLoading();
      this.apiService.post('add-specialisation', this.specialityForm.value).subscribe(
        (res) => {
          this.toastService.dismissLoading();
          if (res.error === false) {
            //console.log('Form Value:: ', this.specialityForm.value);
            //console.log(this.successMessage.replace("%",res.message));
            this.navCtrl.navigateForward(['/confirmation-page'], {
              queryParams: {
                state: this.successMessage.replace("%",res.message),
                hasAddButton: false
              },
            });
          }
        },
        (err) => {
          this.toastService.presentToast('error', 'Something went wrong.');
          this.toastService.dismissLoading();
          //console.log(err);
        }
      );
    } else {
      this.specialityForm.markAllAsTouched();
    }
  }

  updateDateQualified($event) {
    this.DateQualified = $event.detail.value;
  }
}
